export default {"src":"/_next/static/media/MetalWeight.5339f77b.svg","height":28,"width":32};